var styles = {"actions":"styles_actions__3icVs flex col-12 md-col-6 mx-auto","placement-modal":"styles_placement-modal__uYSrE","placementModal":"styles_placement-modal__uYSrE","submit-button":"styles_submit-button__2G-pZ flex-auto","submitButton":"styles_submit-button__2G-pZ flex-auto","back-button":"styles_back-button__2BQ9T","backButton":"styles_back-button__2BQ9T"};

export default styles;
//# sourceMappingURL=styles.css.js.map
